<template>
  <div class="panel-container">
    <component :is="headerComponent" />
    <v-card
      flat
      class="chart-container"
    >
      <v-card-title>
        <h3 class="font-weight-light text-xs-center grow yellow lighten-4">
          タンク / センサー情報
        </h3>
      </v-card-title>
      <div
        v-if="chartLoader"
        class="loader-container"
      >
        <v-progress-circular
          indeterminate
          color="green"
          width="2"
          size="38"
        />
      </div>
      <v-card-text
        v-else
        class="chart-box"
      >
        <Doughnut
          :whole-data="tankInfo.total"
          :part-data="tankInfo.installed"
        />
        <div class="center">
          <p> 総タンク数： </p>
          <p>{{ setCommas(tankInfo.total) }}</p>
        </div>
      </v-card-text>
    </v-card>

    <v-card flat>
      <v-card-title>
        <h3 class="font-weight-light text-xs-center grow yellow lighten-4">
          昨シーズンとの比較
        </h3>
      </v-card-title>
      <v-card-text class="summary-comparison">
        <div class="summary-box" />
        <div class="summary-box summary-title summary-title-top">
          昨シーズン
        </div>
        <div class="summary-box summary-title summary-title-top">
          今シーズン
        </div>
        <div class="summary-box summary-title">
          配送回数
        </div>
        <div class="summary-box summary-text">
          {{ setCommas(yearlyData[0].count) }}回
        </div>
        <div class="summary-box summary-text">
          {{ setCommas(yearlyData[1].count) }}回
        </div>
        <div class="summary-box summary-title">
          配送量
        </div>
        <div class="summary-box summary-text">
          {{ setCommas(yearlyData[0].amount) }}ℓ
        </div>
        <div class="summary-box summary-text">
          {{ setCommas(yearlyData[1].amount) }}ℓ
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Doughnut } from './charts'
import { setCommas } from '@/utils/helpers.js'
export default {
  components: {
    Doughnut
  },
  props: {
    tankInfo: {
      type: Object,
      default: () => {}
    },
    yearlyData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      legendHtml: ''
    }
  },
  computed: {
    ...mapState('dashboard', ['isDelivery', 'chartLoader']),
    headerComponent () {
      return this.isDelivery
        ? () => import('./ActionPanel/DeliverySummary')
        : () => import('./ActionPanel/NormalSummary.vue')
    }
  },
  methods: {
    setCommas (v) {
      return setCommas(v)
    }
  }
}
</script>

<style lang="scss" scoped>

.panel-container {
  background-color: var(--metal-white);
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content 1fr max-content;
  max-height: 690px;
  box-shadow: 1px 1px 4px rgba(0,0,0,0.15);
  border-radius: 3px;
}
/deep/h3 {
  font-size: 1.2rem;
  margin: 0;
  padding: 0.2rem 0;

  &:first-child {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
}
/deep/.summary-table {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 1px;
  justify-content: center;
  align-items: center;
  background-color: #ccc;

  .summary-box {
    padding: 0.6rem 0.8rem;
  }
}
/deep/.summary-box {
  background-color: var(--metal-white);
  box-sizing: content-box;
  white-space: nowrap;
}
/deep/.summary-title {
  color: rgba(0,0,0,0.6);

  &-top {
    text-align: center;
  }
}
/deep/.summary-text {
  text-align: right;
}
.chart-container {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: max-content 1fr;
}
.chart-box {
  height: 100%;
}
.center {
  position: absolute;
  top: 57.5%;
  left: 50%;
  transform: translate(-50%, 0%);
  text-align: center;

  & > p {
    margin: 0;
  }
}

.summary-comparison {
  display: grid;
  grid-template-columns: min-content repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-gap: 1px;
  justify-content: stretch;
  align-items: stretch;
  background-color: #ccc;
  font-size: 0.94rem;

  .summary-box {
    padding: 0.4rem 0.6rem;

    &:first-child {
      background: linear-gradient(18deg, var(--metal-white), var(--metal-white) 49.4%, transparent 49.5%, transparent 51.4%, var(--metal-white) 51.5%);
    }
    &:last-child {
      border-bottom-right-radius: 3px;
    }
    &:nth-last-child(3) {
      border-bottom-left-radius: 3px;
    }
  }
}

.loader-container{
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
}

/deep/.v-card__title {
  padding: 0;
}
/deep/.v-card__text {
  padding: 0;
}
</style>
